<template>
    <div v-cloak class="right-body" id="imageSaverVideoList">
        <div class="imagesaver_content">
            <!-- 清除历史记录 -->
            <div @click="clearTask()" class="video_task_clear">{{$t('language.imageSaver.clearHistory')}}</div>
            <!-- tab -->
            <div class="task-tab-1">
                <el-tabs v-model="activeTab" id="videoTaskListTab" ref="videoTaskListTab">
                    <el-tab-pane :label="$t('language.imageSaver.all')" :name="tabs[0]">
                        <!-- 初始loading -->
                        <div v-if="isInit&&isLoading" class="image_saver_task_not_init"></div>
                        <div class="video-task-items" v-if="!isInit&&allList.length > 0">
                            <div class="video-task-item" v-for="task in allList" :key="task.id">
                                <!-- 封面 -->
                                <div class="item-cover">
                                    <div class="task-audio-thumbnai-mask" v-if="task.category=='Audio'"></div>
                                    <el-image :src="task.thumbnailUrl" :fit="'contain'">
                                        <div slot="error" class="image-slot">
                                            <i class="picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                                <!-- 内容 -->
                                <div class="item-content">
                                    <!-- 标题 -->
                                    <div class="item-content-title" v-ellipsis=2 @click="jumpByUrl(task.url)">
                                        <span v-if="task.category=='thumbnail'">{{"["+$t('language.imageSaver.thumbnail')+"]"}}</span>
                                        {{task.fullTitle}}
                                    </div>
                                    <!-- 属性 -->
                                    <div class="item-content-attr" v-if="task.category!='thumbnail'">
                                        <div style="display: flex;">
                                            <div class="file-type" :class="matchfileType(task.category)"></div>
                                            {{toUpperCase(task.ext)}}
                                        </div>
                                        <span v-if="getQualityTxt(task.resolution)">{{getQualityTxt(task.resolution)}}</span>
                                        <span v-if="!getQualityTxt(task.resolution)&&getAbtTxt(task.abr)">{{$t('language.imageSaver.'+getAbtTxt(task.abr))}}</span>
                                        <span v-if="task.duration">{{task.duration}}</span>
                                        <span v-if="task.fileSize">{{task.fileSize|formatByte}}</span>
                                    </div>
                                </div>
                                <!-- 状态进度 -->
                                <div class="item-status">
                                    <!-- 进度 -->
                                    <div class="item-progress" v-if="task.status=='Running'">
                                        <div>
                                            <el-progress :percentage="task.progress" color="#C1CBE3" :show-text=false ></el-progress>
                                            <div class="item-progress-text">
                                                <span v-if="task.speed">{{task.speed|formatByteSpeed}}</span>
                                                <span v-else>
                                                    <span v-if="task.progress&&task.progress>0">{{$t('language.imageSaver.generat')}}</span>
                                                    <span v-else>{{$t('language.imageSaver.taskQueue')}}</span>
                                                </span>
                                                <span v-if="task.progress">{{task.progress + "%"}}</span>
                                                <span v-else>0%</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 状态 -->
                                    <div class="item-state" v-else>
                                        <div class="item-state-item" v-if="task.status=='Fail' && task.notEnough">
                                            <img src="../../assets/images/imageSaver/widthWarning.svg" >
                                            <div style="color: #E09D00">
                                                {{$t('language.popup.upgradeAccountPopup.insufficientTraffic')}}
                                            </div>
                                        </div>
                                        <div class="item-state-item" v-if="task.status=='Fail' && !task.notEnough">
                                            <img src="../../assets/images/imageSaver/widthError.svg" >
                                            <div style="color: #F54958">
                                                {{$t('language.common.failure')}}
                                            </div>
                                        </div>
                                        <div class="item-state-item" v-if="task.status=='Done'">
                                            <img src="../../assets/images/imageSaver/widthSuccess.svg" >
                                            <div style="color:#30A734">
                                                {{$t('language.common.success')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 按钮 -->
                                <div class="item-btns">
                                    <!-- 关闭 -->
                                    <div class="item-btn" v-if="task.status=='Running'">
                                        <button class="cancel-button" @click="cancelTask(task)">{{$t('language.common.cancel')}}</button>
                                    </div>
                                    <!-- 重启或付费 -->
                                    <div class="item-btn" v-if="task.status=='Fail'">
                                        <!-- 重启 -->
                                        <div class="retry" @click="retryTask(task)"></div>
                                        <!-- 付费 -->
                                        <button class="upgrade-btn" @click="switchToPay()" v-if="userTrafficIsNoEnough()">
                                            <img src="../../assets/images/imageSaver/widthUpgrade.svg" >
                                            {{$t('language.rightTopBanner.upgrade')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 没有任务 -->
                        <div v-if="!isInit&&!allList.length" class="video_task_no">
                            <img src="../../assets/images/imageSaver/finishedNoTask.png" />
                            <div>{{ $t('language.imageSaver.noTask') }}</div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.imageSaver.finished')" :name="tabs[1]">
                        <!-- 初始loading -->
                        <div v-if="isInit&&isLoading" class="image_saver_task_not_init"></div>
                        <div class="video-task-items" v-if="!isInit&&finishedList.length > 0">
                            <div class="video-task-item" v-for="task in finishedList" :key="task.id">
                                <!-- 封面 -->
                                <div class="item-cover">
                                    <div class="task-audio-thumbnai-mask" v-if="task.category=='Audio'"></div>
                                    <el-image :src="task.thumbnailUrl" :fit="'contain'">
                                        <div slot="error" class="image-slot">
                                            <i class="picture-outline"></i>
                                        </div>
                                    </el-image>
                                </div>
                                <!-- 内容 -->
                                <div class="item-content">
                                    <!-- 标题 -->
                                    <div class="item-content-title" v-ellipsis=2 @click="jumpByUrl(task.url)">
                                        <span v-if="task.category=='thumbnail'">{{"["+$t('language.imageSaver.thumbnail')+"]"}}</span>
                                        {{task.fullTitle}}
                                    </div>
                                    <!-- 属性 -->
                                    <div class="item-content-attr" v-if="task.category!='thumbnail'">
                                        <div style="display: flex;">
                                            <div class="file-type" :class="matchfileType(task.category)"></div>
                                            {{toUpperCase(task.ext)}}
                                        </div>
                                        <span v-if="getQualityTxt(task.resolution)">{{getQualityTxt(task.resolution)}}</span>
                                        <span v-if="!getQualityTxt(task.resolution)&&getAbtTxt(task.abr)">{{$t('language.imageSaver.'+getAbtTxt(task.abr))}}</span>
                                        <span v-if="task.duration">{{task.duration}}</span>
                                        <span v-if="task.fileSize">{{task.fileSize|formatByte}}</span>
                                    </div>
                                </div>
                                <!-- 状态进度 -->
                                <div class="item-status">
                                    <!-- 状态 -->
                                    <div class="item-state">
                                        <div class="item-state-item" v-if="task.status=='Fail'">
                                            <img src="../../assets/images/imageSaver/widthError.svg" >
                                            <div style="color: #F54958">
                                                {{$t('language.common.failure')}}
                                            </div>
                                        </div>
                                        <div class="item-state-item" v-if="task.status=='Done'">
                                            <img src="../../assets/images/imageSaver/widthSuccess.svg" >
                                            <div style="color:#30A734">
                                                {{$t('language.common.success')}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 按钮 -->
                                <div class="item-btns">
                                    <!-- 重启或付费 -->
                                    <div class="item-btn" v-if="task.status=='Fail'">
                                        <!-- 重启 -->
                                        <div class="retry" @click="retryTask(task)"></div>
                                    </div>
                                    <!-- 完成 -->
                                    <div class="item-btn" v-if="task.status&&task.status!='Fail'">
                                        <div class="view" @click="viewTask(task)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 没有任务 -->
                        <div v-if="!isInit&&!finishedList.length" class="video_task_no">
                            <img src="../../assets/images/imageSaver/finishedNoTask.png" />
                            <div >{{ $t('language.imageSaver.noTask') }}</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 付费用户升级 -->
        <upgradeVipDialog ref="upgradeVipDialog"></upgradeVipDialog>
        <!-- 免费用户升级 -->
        <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
    </div>
</template>

<script>
import '@/assets/css/tab.css';
import commonUtils from "@/js/workspace/common_util.js";
import requestUtils from '@/js/request_util.js';
import upgradeVipDialog from "@/components/popup/upgrade_popups/upgrade_account_vip_popup";
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
export default {
    name: "videoTaskListPopup",
    data: function () {
        return {
            isLoading: false,//是否正在刷新页面
            isInit: false,//是否是初次加载
            errorNum: 0,//刷新错误次数
            activeTab: "",
            allList: [],//上传中任务集合
            finishedList: [],//已完成任务集合
            hasRunning: false,//是否有运行中任务
            refreshTimer: null,//刷新定时器
            tabs: ["uploading","finished"],
            videoTypes: ['Video'],//视频类型列表
            audioTypes: ['Audio'],//音频类型列表
            progressMap: {},//任务进度记录
            isRunning: false,//正在运行的任务id，没有则是false
        };
    },
    components: {
        upgradeVipDialog,
        upgradeNewDialog,
    },
    mounted() {
        this.isInit = true;//标记初次加载
        this.init();
        this.activeTab = this.tabs[0];
        this.repairTabUnderline();
    },
    beforeDestroy() {
        //关闭定时器
        this.closeRefreshTasks();
    },
    computed: {
        
    },
    watch:{
        hasRunning(newV,oldV) {
            //值变更时修改定时器状态
            newV?this.refreshTasks():this.closeRefreshTasks();
        },
    },
    methods: {
        //初始化列表
        init() {
            if(!this.isLoading){
                this.isLoading = true;
                requestUtils.doVideoSaverRequest("list_task",{ud:commonUtils.getUser().id}).then(res => {
                    this.isLoading = false;
                    this.isInit = false;//标记初次加载结束
                    if(res.code == 200 && res.message=="success"){
                        this.errorNum = 0;
                        this.getTaskListsByTab(res.data);
                    }else {
                        this.errorNum++;
                        if(this.errorNum<6){
                            setTimeout(() => {
                                this.init();
                            }, 3000);
                        }
                    }
                });
            }
        },
        //拆分任务集合到不同tab页集合中
        getTaskListsByTab(tasks) {
            var allList = [];
            var finishedList = [];
            let isRunning = false;
            let isWaiting = 0;
            tasks.forEach(task => {
                if(task.status === "Running" || task.status === "Create" || (task.status === "Fail" && task.msg === "traffic not enough")) {
                    //运行中任务或创建中任务或流量不足的失败任务
                    if(task.status === "Running") {
                        let taskProgress = this.getProgress(task.id);
                        if(taskProgress) {
                            task.progress = taskProgress.progress;
                            task.speed = taskProgress.speed;
                        }
                        //如果有执行中的任务，则只需要更新当前任务信息
                        isRunning = task.id;
                    }else if(task.status === "Create") {
                        isWaiting += 1;
                    }else if(task.status === "Fail" && task.msg === "traffic not enough") {
                        task.notEnough = true;
                    }
                }else {
                    //其他已完成任务
                    finishedList.push(task);
                }
                allList.push(task);
            });
            //排序
            this.allList = allList.sort((a, b) => b.ctime - a.ctime);
            this.finishedList = finishedList.sort((a, b) => b.mtime - a.mtime);
            //控制获取进度定时器
            this.hasRunning = isRunning||isWaiting > 0;
            this.isRunning = isRunning;
        },
        //刷新任务列表
        refreshTasks() {
            if(!this.refreshTimer){
                 //如果定时器不存在，则创建
                this.refreshTimer = setInterval(() => {
                    if(this.isRunning) {
                        //有运行中任务只需要更新运行中任务
                        this.getUploadTask(this.isRunning);
                    }else {
                        //否则更新所有任务，直到没有等待任务
                        this.init();
                    }
                }, 5000);
            }
        },
        //异步获取运行任务信息
        async getUploadTask(id) {
            requestUtils.doVideoSaverRequest("get_task",{ud:commonUtils.getUser().id,id:id}).then(res => {
                if(res.code == 200 && res.message=="success"){
                    //判断任务状态
                    var task = res.data;
                    //未完成
                    if(task.status=="Running") {
                        //获取并记录进度
                        let nowTime = new Date().getTime()
                        let times = nowTime - task.ctime;
                        let speed = (task.fileSize&&times>0)?(task.fileSize/Math.floor(times/1000)).toFixed(2):0;
                        this.progressMap[task.id] = {
                            progress: Number(task.msg),
                            speed: speed,
                            time: nowTime
                        }

                        let index = this.allList.findIndex(item => item.id === task.id);
                        this.allList[index].progress = Number(task.msg);
                        this.allList[index].speed = speed;
                        this.$forceUpdate()
                    }else if(task.status=="Done" || task.status=="Fail") {
                        //完成并刷新任务列表
                        this.init();
                    }
                }
            });
        },
        //关闭刷新任务列表
        closeRefreshTasks() {
            if(this.refreshTimer){
                clearInterval(this.refreshTimer);
            }
        },
        //关闭任务
        cancelTask(task) {
            requestUtils.doVideoSaverRequest("cancel_task",{ud:commonUtils.getUser().id,id:task.id}).then(res => {
                if(res.code == 200 && res.message=="success"){
                    //关闭成功后刷新列表
                    this.init();
                }
            });
        },
        //重试任务
        retryTask(task) {
            var data = JSON.parse(JSON.stringify(task));
            data.ud = commonUtils.getUser().id;
            requestUtils.doVideoSaverRequest("retry_task",data).then(res => {
                if(res.code == 200 && res.message=="success"){
                    if(this.activeTab == this.tabs[1]) {
                        this.$toast({
                            text: this.$t('language.imageSaver.retryTip'),
                            type: 'success',
                            idValue: "imageSaverVideoList"
                        });
                    }
                    //关闭成功后刷新列表
                    this.init();
                }
            });
        },
        //清空历史记录
        clearTask() {
            requestUtils.doVideoSaverRequest("clear_history",{ud:commonUtils.getUser().id}).then(res => {
                if(res.code == 200 && res.message=="success"){
                    //关闭成功后刷新列表
                    this.allList = [];
                    this.finishedList = [];
                }
            });
        },
        switchToPay() {
            let user = commonUtils.getUser();
            if (user.vip) {
                var upgradeVipDialog = this.$refs.upgradeVipDialog;
                upgradeVipDialog.title = this.$t('language.paySystem.supportItem.vipPopupTitleTraffic');
                upgradeVipDialog.desc = this.$t('language.paySystem.supportItem.vipPopupDescTraffic');
                upgradeVipDialog.isShow = true;
            } else {
                var upgradeNewDialog = this.$refs.upgradeNewDialog;
                upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_traffic');
                upgradeNewDialog.curItem = 'traffic';
                upgradeNewDialog.isShow = true;
            }
        },
        //跳转到对应列表
        viewTask(task) {
            var index = null;
            var drives = this.$store.getters.getUsersDrives;
            for (var i=0; i<drives.length; i++) {
                if (drives[i].id == task.cloudToId) {
                    index = i;
                    break;
                }
            }
            // 选择该云盘
            if (index) {
                this.$store.commit('setleftbannerMenuClick', drives[index].id);
            }
            // 跳转路径处理
            var data = [];
            var nodes = JSON.parse(task.nodes);
            // 使用最新的云盘名称
            nodes[nodes.length-1].name = drives[index].name;
            for (var i=0; i<nodes.length; i++) {
                var node = {};
                node.fileName = nodes[i].name;
                node.tokenId = task.cloudToId,
                node.cloudType = drives[index].driveType;
                node.fileId = nodes[i].id;
                data.push(node);
            }
            commonUtils.encapsulationPath(data);
            // 跳转到云盘管理
            this.$router.push({
                name: "cloudExploer",
                query: {
                    folderName: nodes[0].name,
                    tokenId: task.cloudToId,
                    cloudType: drives[index].driveType,
                    folderId: nodes[0].id,
                }
            });
            this.$multcloudGA('video_view');
        },
        //跳转到原链接
        jumpByUrl(url) {
            window.location.href = url;
        },
        // 修复任务列表Tab下划线错位问题
        repairTabUnderline() {
            // Tab
            var videoTaskListTab = this.$refs.videoTaskListTab;
            // 激活的Tab
            var activeTab = this.activeTab;
            // Tab的索引
            var tabIndex = 0;
            // 是否是开始和结束Tab
            var isFirstLast = false;
            // 确定 Tab的索引 和 是否是开始和结束Tab
            if (activeTab == this.tabs[0]) {
                tabIndex = 0;
                isFirstLast = true;
            } else if (activeTab == this.tabs[1]) {
                tabIndex = 1;
                isFirstLast = false;
            }
            // 处理Tab下划线
            clearInterval(this.checkSubTabSelect);
            this.checkSubTabSelect = setInterval(() => {
                var tabs = videoTaskListTab.$children[0].$refs.tabs;
                if (tabs[tabIndex]) {
                    var width = tabs[tabIndex].clientWidth - (isFirstLast?20:40);
                    var offsetLeft = tabs[tabIndex].offsetLeft;
                    if (tabIndex > 0) offsetLeft += 20;
                    if (width > 0) {
                        var style = videoTaskListTab.$children[0].$children[0].$el.style;
                        // 移除动画
                        style.transition = 'none';
                        // 设置位置
                        style.transform = 'translateX('+offsetLeft+'px)';
                        // 设置宽度
                        style.width = width + 'px';
                        // 添加动画
                        setTimeout(() => {
                            style.transition = 'transform .3s cubic-bezier(.645,.045,.355,1), -webkit-transform .3s cubic-bezier(.645,.045,.355,1)';
                        }, 500);
                        clearInterval(this.checkSubTabSelect);
                    }
                }
            }, 10);
        },
        //字符串转大写
        toUpperCase(str) {
            if(str){
                return str.toString().toUpperCase();
            }else {
                return str;
            }
        },
        //音视频图标判断
        matchfileType(type) {
            if(this.videoTypes.includes(type)) {
                return "video";
            }else if(this.audioTypes.includes(type)) {
                return "audio";
            }else {
                return type;
            }
        },
        //获取分辨率文本
        getQualityTxt(resolution) {
            let num;
            if(resolution) {
                //处理视频分辨率
                let resolutionList = resolution.match(/\d+(\.\d+)?/g);
                if(resolutionList&&resolutionList.length>1){
                    let resolution0 = parseInt(resolutionList[0]);
                    let resolution1 = parseInt(resolutionList[1]);
                    //处理分辨率
                    num = resolution0 > resolution1? resolution1 : resolution0;
                }
            }else {
                num = -1;
            }

            let quality;
            if(num > 1080){
                quality = Math.floor(num / 500) + "K";
            }else if(num > 0){
                quality = num + "P";
            }else {
                quality = false;
            }
            return quality;
        },
        //获取清晰度文本
        getAbtTxt(abr) {
            if(abr && abr>0) {
                return abr>96?abr>192?abr>320?'abrTypeVeryHigh':'abrTypeHigh':'abrTypeNormal':'abrTypeLow';
            }else {
                return false;
            }
        },
        userTrafficIsNoEnough() {
            var user = commonUtils.getUser();
            if(user.vip) {
                if(user.payLevel!=1&&user.payUsedTraffic >= user.payTotalTraffic) {
                    //无限用户一定时充足的
                    //已使用流量大于等于总流量
                    return true;
                }
            }else {
                if(user.freeUsedTraffic >= user.freeTotalTraffic) {
                    //免费用户已使用流量大于等于总流量
                    return true;
                }
            }
            return false;
        },
        //获取进度
        getProgress(id) {
            let task = this.progressMap[id];
            if(task) {
                return task;
            }
        },
    },
    directives: {
        ellipsis: {
            //是否显示title和尾部...
            inserted: function (el, binding) {
                // 获取期望的文本行数，默认为1
                const n = binding.value || 1;
                if ((el.clientHeight+(el.clientHeight/n)) <= el.scrollHeight) {
                    el.title = el.innerText;
                }else {
                    el.title = "";
                }
            },
            componentUpdated: function (el, binding) {
                // 获取期望的文本行数，默认为1
                const n = binding.value || 1;
                if ((el.clientHeight+(el.clientHeight/n)) <= el.scrollHeight) {
                    el.title = el.innerText;
                }else {
                    el.title = "";
                }
            },
        },
    },
}
</script>

<style scoped>
#videoTaskListPopup {
    width: 1200px;
    /*no*/
    height: 750px;
    /*no*/
}

.imagesaver_content {
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
    padding: 20px 50px;
    /*no*/
}

.popup-body {
    position: relative;
    overflow: auto;
    padding: 5px 20px 20px 20px;
    /*no*/
    margin: 0;
    height: calc(100% - 65px);
    /*no*/
    background: #F2F7FE;
}

.video_task_clear {
    height: 30px;
    /*no*/
    line-height: 30px;
    /*no*/
    padding: 0 0px 0 35px;
    /*no*/
    background-position: 10px center;
    /*no*/
    background-repeat: no-repeat;
    background-image: url("../../assets/images/imageSaver/clearHistory.svg");
    font-size: 14px;
    /*no*/
    color: #5562B4;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    right: 50px;
    /*no*/
    top: 20px;
    /*no*/
}

#videoTaskListPopup .task-tab-1 {
    margin-top: 20px;
    /*no*/
}

#videoTaskListPopup .task-tab-1 >>> .el-tabs__item {
    font-size: 14px;
    /*no*/
    padding-top: 10px;
    /*no*/
    line-height: 30px;
    /*no*/
}

#videoTaskListPopup .task-tab-1 >>> .el-tabs__content {
    padding: 0;
    margin-top: 20px;
    /*no*/
}

.video-task-items {
    display: flex;
    flex-direction: column;
    gap: 15px;
    /*no*/
}

.video-task-item {
    display: flex;
    align-items: center;
    gap: 20px;
    /*no*/
    padding: 10px;
    /*no*/
    height: 128px;
    /*no*/
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #D3DCF0;
    /*no*/
}

.item-cover {
    width: 192px;
    /*no*/
    height: 108px;
    /*no*/
    flex: 0 0 192px;
    /*no*/
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative;
}

.item-cover .el-image {
    width:100%;
    height:100%;
}

.item-cover .el-image >>> .el-image__inner {
    background: rgba(0, 0, 0, 0.08);
}

.item-cover .picture-outline {
    width: 192px;/*no*/
    height: 108px;/*no*/
    background: url("../../assets/images/imageSaver/coverError.svg") center no-repeat,rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: center;
    align-items: center;
}

.item-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    /*no*/
    width: 50%;
    /*no*/
    height: 86px;
    /*no*/
}

.video-task-item:hover .item-content-title {
    color: #5562B4;
}

.item-content-title img{
    display: none;
    margin: 5px 7px 0px 6px;
    /*no*/
}

.item-content-title {
    height: 50px;
    /*no*/
    width: 587px;
    /*no*/
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: inherit;
    -webkit-line-clamp: 2;
    cursor: pointer;
    position: relative;
    font-size: 18px;
    /*no*/
    font-weight: bold;
    line-height: 25px;
    /*no*/
    letter-spacing: 0em;
    position: relative;
    padding-right: 20px;
    /*no*/
}

.item-content-attr {
    display: flex;
    gap: 15px;
    /*no*/
    height: 16px;
    /*no*/
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 16px;
    /*no*/
    letter-spacing: 0em;
    color: #6F6F6F;
}

.item-content-attr span::before {
    content: '·';
    margin-right: 15px;
    /*no*/
    clear: both;
    font-weight: bold;
}

.item-status {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 300px;
    /*no*/
}

.item-progress {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.item-progress-text {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    /*no*/
    font-weight: normal;
    line-height: 14px;
    /*no*/
    letter-spacing: 0em;
    margin-top: 10px;
    /*no*/
    color: #6F6F6F;
}

.item-state {
    font-size: 14px;
    /*no*/
}

.item-state-item {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    /*no*/
}


.item-btns {
    display: flex;
    justify-content: flex-end;
    flex-grow: 1;
    margin-right: 10px;
    /*no*/
}

.video-task-item:hover .item-btn {
    display: flex;
    align-items: center;
}

.item-btn {
    display: none;
}

.item-btn button{
    width: 120px;
    /*no*/
    height: 30px;
    /*no*/
}

.cancel-button {
    border: 1px solid rgba(0, 0, 0, 0.08);
    /*no*/
    color: #000000 !important;
}

.retry {
    cursor: pointer;
    width: 24px;
    /*no*/
    height: 24px;
    /*no*/
    margin: 12px;
    /*no*/
    margin-right: 40px;
    /*no*/
    background: url("../../assets/images/imageSaver/widthRetry.svg") no-repeat 100%;
}

.view {
    cursor: pointer;
    width: 24px;
    /*no*/
    height: 24px;
    /*no*/
    margin: 12px;
    /*no*/
    background: url("../../assets/images/imageSaver/widthView.svg") no-repeat 100%;
}

.upgrade-btn {
    height: 30px;
    /*no*/
    background: linear-gradient(173deg, #FFA133 5%, #F58427 77%);
    font-size: 12px;
    /*no*/
    font-weight: bold;
    float: right;
    text-align: center;
    line-height: 30Px;
    /*no*/
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
    /*no*/
}

.file-type {
    width: 16px;
    /*no*/
    height: 16px;
    /*no*/
    float: left;
    margin-right: 5px;
    /*no*/
}

/* 没有任务图标和文字定位 */
.video_task_no {
    width: 140px; /*no*/
    height: 140px; /*no*/
    position: absolute;
    z-index: 1;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

/* 没有任务文字 */
.video_task_no>div {
    margin-top: 20px; /*no*/
    font-size: 24px; /*no*/
    font-weight: bold;
    color: #C1CBE3;
    text-align: center;
}

/* 任务未初始化 */
.image_saver_task_not_init {
    background-position: center;
    background-repeat: no-repeat;
    background-image: url("../../assets/images/imageSaver/bigLoading.svg");
    animation: rotating 2s linear infinite;
    width: 300px; /*no*/
    height: 300px; /*no*/
    position: absolute;
    z-index: 2;
    margin: auto;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
}

.task-audio-thumbnai-mask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: url("../../assets/images/imageSaver/audio_mask.png") no-repeat center,linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}

/* 滚动条 */
#videoTaskListTab .el-tabs__content::-webkit-scrollbar {
    width: 6px; /*no*/
    height: 6px; /*no*/
    background-color: transparent;
}

/* 滚动条 */
#videoTaskListTab .el-tabs__content::-webkit-scrollbar-thumb {
    width: 4px; /*no*/
    height: 4px; /*no*/
    border-radius: 4px; /*no*/
    background: #BECAE4;
    min-height: 100px; /*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/video_saver_list.vue